import { BehaviorSubject } from 'bog-arcade-core-ui/observer/BehaviorSubject';
import { GameApplicationType, GameMode, GameSceneType } from '../core/enums';

export const CANVAS_GAME_LOADED = new BehaviorSubject(false);

export const GAME_APPLICATION_TYPE_STATE = new BehaviorSubject(GameApplicationType.web);
export const GAME_APPLICATION_SCENE_STATE = new BehaviorSubject(GameSceneType.main);
export const GAME_APPLICATION_MODE_STATE = new BehaviorSubject(GameMode.demo);

export const AMOUNT_COST_VALUE_STATE = new BehaviorSubject(1000);

export const FREE_SPIN_COUNT_STATE = new BehaviorSubject(0);
export const MULTIPLIER_STATE = new BehaviorSubject(0);
export const MULTIPLIER_BLINKING_STATE = new BehaviorSubject(false);
export const BONUS_GAME_BALLS = new BehaviorSubject([]);
export const BONUS_GAME_BALLS_CRACKS = new BehaviorSubject([]);
export const BONUS_BALL_CRACK = new BehaviorSubject(0);
export const BONUS_RESPONSE = new BehaviorSubject(null);
export const BONUS_TICKET_TYPE = new BehaviorSubject(null);
export const TOTAL_WIN_STATE = new BehaviorSubject(0);
export const BONUS_WIN_STATE = new BehaviorSubject(0);
export const BONUS_SPIN_RESPONSE = new BehaviorSubject({});
export const BONUS_TOTAL_ODD = new BehaviorSubject(0);
export const ACTIVE_ODD = new BehaviorSubject(null);
export const SPIN_RESPONSE_DATA = new BehaviorSubject({});
export const PRE_BONUS_ID = new BehaviorSubject(null);

export const SPINE_RESPONSE = new BehaviorSubject(null);

export const SOUND_ICON_STATE = new BehaviorSubject(false);
export const INFO_ICON_STATE = new BehaviorSubject(false);
export const HISTORY_ICON_STATE = new BehaviorSubject(false);
export const HISTORY_LIST = new BehaviorSubject([]);

export const BONUS_COST_AMOUNT = new BehaviorSubject(null);
export const BALANCE_VALUE = new BehaviorSubject('');
export const LAST_WIN_VALUE = new BehaviorSubject('');
export const BIG_WIN_STATE = new BehaviorSubject(false);
export const SCREEN_TRANSACTION_STATE = new BehaviorSubject(false);

export const USER_DATA = new BehaviorSubject({ id: 12345678 });
